import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

type SectionBackButtonProps = {
  to: string;
  label: string;
};

const SectionBackButton: React.FC<SectionBackButtonProps> = ({ to, label }) => {
  const navigate = useNavigate();

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-6">
      <button
        type="button"
        onClick={() => navigate(to)}
        className="inline-flex items-center gap-2 rounded-md border border-theme-primary bg-theme-primary px-3 py-1.5 text-sm text-theme-secondary hover:bg-theme-secondary/10"
      >
        <ArrowLeft className="h-4 w-4" />
        {label}
      </button>
    </div>
  );
};

export default SectionBackButton;
